import { ICellRendererParams } from "ag-grid-community";
import { RATIO_PLAN_METRICES } from "@/ts/constants";

const PlanMetricIndicatorCellRenderer = ({
    colDef,
    data,
    value,
    node,
}: ICellRendererParams) => {
    if (node.rowPinned) return null;

    const columnMetric = colDef.field.split("_")[1];
    const isRatioMetric = RATIO_PLAN_METRICES.includes(columnMetric);
    const targetMetricValue = data[columnMetric];
    const isMetricTargetMet = isRatioMetric
        ? value >= targetMetricValue
        : value >= 100;

    return (
        <div
            style={{
                border: "1px solid #d3d3d3",
                fontWeight: "bold",
                textAlign: "center",
                backgroundColor: isMetricTargetMet ? "#A8E6CF" : "#FF8383",
                color: isMetricTargetMet ? "#005700" : "#8E1616",
            }}
        >
            {value}{isRatioMetric ? "" : "%"}
        </div>
    );
};

export default PlanMetricIndicatorCellRenderer;
